<div class="page">
  <div class="content">
    <div class="main">
      <div class="header">
        <img class="img" src="./assets/images/logo-dark.svg" loading="lazy" height="32px" alt="sepidz logo" />
      </div>
      <div class="contactinfo">
        <div class="boxinfo">
          <div class="info1">
            <i class="icon-info-24px contacticon"></i>
            <span class="time">
              {{ "ClientApp.Projects.FrameWorkShell.Header.CallInfo.CompanyWorkingHours" | translate }}:
              {{ "ClientApp.Projects.FrameWorkShell.Header.CallInfo.TimeWork" | translate }}</span
            >
          </div>
          <div class="info2">
            <i class="icon-call-o contacticon"></i>
            <span>021-91002030</span>
          </div>
        </div>
        <div class="boxinfo">
          <div class="info1">
            <i class="icon-instagram1 contacticon"></i>
            <span>SepidzPos</span>
          </div>
          <div class="info2">
            <i class="icon-person_outline-o contacticon"></i>
            <span> {{ "ClientApp.Projects.FrameWorkShell.Header.CallInfo.CustomerCode" | translate }}</span>
            <span>
              {{ currentInformation?.LockNumber }}
            </span>
          </div>
        </div>
        <div class="boxinfo">
          <div class="info1">
            <i class="icon-globe contacticon"></i>
            <span class="website-link">
              <a target="_blank" href="https://www.sepidz.com">www.sepidz.com</a>
            </span>
          </div>
          <div class="info2">
            <span class="d-flex">
              <i class="icon-dynamic_feed-F contacticon"></i>
              <span> {{ "ClientApp.Projects.FrameWorkShell.Header.CallInfo.SoftwareVersion" | translate }}</span>
            </span>
            <span>
              {{ currentInformation?.ProductVersion }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer justify-content-between align-items-center">
      <ssg-button [label]="'ClientApp.Projects.FrameWorkShell.Header.CallInfo.Close' | translate" (click)="close()"></ssg-button>
      <a target="_blank" href="https://sc.sepidz.com">{{ "ClientApp.Projects.FrameWorkShell.Header.CallInfo.RemoteCommunication" | translate }}</a>
    </div>
  </div>
  <div class="leftbox">
    <i class="icon-info-24px"></i>
    <div class="title">{{ "ClientApp.Projects.FrameWorkShell.Header.CallInfo.AboutUs" | translate }}</div>
  </div>
</div>
